/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { GDSStackLayoutProps, StackLayout } from '@leagueplatform/genesis-core';
import {
  ErrorState as WebCommonErrorState,
  ErrorStateProps as WebCommonErrorStateProps,
} from '@leagueplatform/web-common-components';
import { FullScreenContainer } from '../full-screen-container.component';

export type ErrorStateProps = WebCommonErrorStateProps & {
  isFullPage?: boolean;
  styleProps?: Partial<GDSStackLayoutProps>;
};

export const ErrorState = ({
  styleProps,
  isFullPage = false,
  ...errorStateProps
}: ErrorStateProps) => {
  if (isFullPage) {
    return (
      <FullScreenContainer horizontalAlignment="center">
        <StackLayout
          verticalAlignment="center"
          {...styleProps}
          css={{
            textAlign: 'center',
            maxWidth: '350px',
            ...styleProps?.css,
          }}
        >
          <WebCommonErrorState {...errorStateProps} />
        </StackLayout>
      </FullScreenContainer>
    );
  }

  return (
    <StackLayout
      {...styleProps}
      css={{
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        ...styleProps?.css,
      }}
    >
      <WebCommonErrorState {...errorStateProps} />
    </StackLayout>
  );
};
